import { PRIVACY_POLICY, PRIVACY_POLICY_FR } from "@recare/core/consts";
import { getStaticAsset } from "@recare/core/model/config";
import { AnyFunction } from "@recare/core/types";
import { useCallback } from "react";
import { useCountry } from "reduxentities/selectors/hooks";

export default function usePrivacyPolicyLink(
  onClick?: AnyFunction | undefined,
) {
  const isFrance = useCountry() === "FR";
  const privacyPolicyLink = isFrance ? PRIVACY_POLICY_FR : PRIVACY_POLICY;
  return useCallback(
    () =>
      window.open(getStaticAsset(privacyPolicyLink), "_blank") &&
      onClick?.(),
    [onClick],
  );
}
